import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User opened the smart resize menu on a canvas node',
  name: 'canvas_smart_resize_menu_opened',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The type of node the smart resize menu was opened on',
      name: 'node_type',
      required: true,
      type: 'enum',
      values: ['image', 'video'],
    },
  ],
};

export default META;
